interface Props {
	onLoad?: () => void;
}
const Logo: React.FC<Props> = ({ onLoad }) => <img onLoad={onLoad} src="/logo.svg" alt="Evidia logo" />;

export default Logo;
